import ReceiveReminderManagement from './ReceiveReminderManagement.vue'
export default ReceiveReminderManagement



// WEBPACK FOOTER //
// ./src/pages/ReceiveReminderManagement/index.js